<template>
  <div
    v-if="loading"
    class="st-vue-loader st-spinner stilingue-colors st-spinner-three-bounce st-vue-loader--small"
  >
    <div
      v-for="index in maxCircles"
      :key="index"
      :class="getCircleClass(index)"
    />
  </div>
</template>

<script>
export default {
  name: 'StLoader',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    useFixedId: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      maxCircles: 3,
      staticParentClass: 'st-loader-parent'
    };
  },
  watch: {
    loading: {
      handler: 'setLoaderParentWithRelativePosition',
      immediate: true
    }
  },
  methods: {
    getCircleClass(index) {
      return `st-bounce${index}`;
    },
    /**
     * The Loader only behaviour correctly when the parent has position RELATIVE.
     * This function force the parents to be position static.
     * First it wait loader to be render in the dom, then find the loader,
     * find the parent Element and append the positionRelativeClass.
     */
    setLoaderParentWithRelativePosition() {
      this.$nextTick(() => {
        const $el = this.$parent.$el;

        if ($el && $el.classList) {
          $el.classList.add(this.staticParentClass);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.st-vue-loader {
  width: 70px !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
}

.st-vue-loader--small {
  height: 11px !important;

  div {
    width: 11px !important;
    height: 11px !important;
  }
}

.st-spinner-three-bounce div {
  vertical-align: top;
  width: 18px;
  height: 18px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  animation: st-threeBounceDelay 1.5s infinite ease-in-out;
  animation-fill-mode: both;
  will-change: transform;
}

.st-vue-loader--small .st-bounce1 {
  background-color: #00aaa7 !important;
  margin: 0 10% 0 0 !important;
  animation-delay: -0.9s !important;
}

.st-vue-loader--small .st-bounce2 {
  background-color: #ffb500 !important;
  margin: 0 10% 0 0 !important;
  animation-delay: -0.6s !important;
}

.st-vue-loader--small .st-bounce3 {
  background-color: #e64b73 !important;
  margin: 0 10% 0 0 !important;
  animation-delay: -0.3s !important;
}

.st-spinner-three-bounce .st-bounce1 {
  margin: 0 30% 0 0;
}

.st-spinner-three-bounce .st-bounce2 {
  margin: 0 0 0 30%;
}

.st-spinner-three-bounce .st-bounce3 {
  animation-delay: 0.3s;
  margin: 0 35% 0 35%;
}

@keyframes st-threeBounceDelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  30% {
    transform: scale(1);
  }
}
</style>

<style lang="scss">
.st-loader-parent {
  position: relative !important;
}
</style>
